// extracted by mini-css-extract-plugin
export default {"heading2":"heading-02_heading2__mxJ-7","semibold":"heading-02_semibold__h18sA","bold":"heading-02_bold__l3Olq"};